import { useState } from 'react';
import { SORT_ORDER_KEY } from '../../types';
import { inMemoryKVStore } from '../../../../../infra/persistence';
export var sortOrders = {
    createdAtDesc: 'createdAt:desc',
    createdAtAsc: 'createdAt:asc',
    successDesc: 'totalUniqueOpenRateCounter:desc,revenue:desc',
    displayNameAsc: 'displayName:asc',
};
export var useTableSort = function () {
    var _a = useState(inMemoryKVStore.getItem(SORT_ORDER_KEY) || 'createdAtDesc'), sortName = _a[0], setLocalSortName = _a[1];
    var setSortName = function (newSortName) {
        setLocalSortName(newSortName);
        inMemoryKVStore.setItem(SORT_ORDER_KEY, newSortName);
    };
    return {
        sortName: sortName,
        setSortName: setSortName,
        sortValue: sortOrders[sortName],
    };
};
